(() => {
  'use strict';

  const mergeHeadingIntoHero = (page) => {
    const heroCopy = page.querySelector('.mb-v126-maker-hero > .mb-intro');
    const heading = page.querySelector(':scope .mb-productkop');
    if (!heroCopy || !heading || heroCopy.contains(heading)) return;
    heroCopy.appendChild(heading);
  };

  const init = (scope = document) => {
    scope.querySelectorAll?.('.mb-page-content[data-page-handle="auteurs"], .mb-page-content[data-page-handle="illustratoren"]')
      .forEach(mergeHeadingIntoHero);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
